import { render } from "./portletTemplateListView.vue?vue&type=template&id=39ad942e&scoped=true"
import script from "./portletTemplateListView.vue?vue&type=script&lang=js"
export * from "./portletTemplateListView.vue?vue&type=script&lang=js"

import "./portletTemplateListView.vue?vue&type=style&index=0&id=39ad942e&scoped=true&lang=css"
import "./portletTemplateListView.vue?vue&type=style&index=1&id=39ad942e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ad942e"]])

export default __exports__